<template>
  <div v-if="categoryInfo.sub_categories?.length" class="container mx-auto">
    <n-tabs v-model:value="subCategoryId" justify-content="start">
      <n-tab v-for="category in subCategories" :key="category.id" :name="category.id || 0">{{ category.name }}</n-tab>
    </n-tabs>
  </div>
</template>

<script lang="ts" setup>
import { NTabs, NTab } from 'naive-ui'

import { ALL_SUB_CATEGORY_ID } from '@/constants/commons'
import type { ScategorySubCategory } from '@/types/api'

const subCategoryId = defineModel<number>({ default: 0 })

const { t } = useI18n()

const { category: categoryInfo } = useCategory()

const subCategories = computed(() =>
  [{ id: ALL_SUB_CATEGORY_ID, name: t('branch_list.subcategory.all') } as ScategorySubCategory].concat(categoryInfo.value.sub_categories || [])
)
</script>

<style lang="scss" scoped>
:deep(.n-tabs) {
  .v-x-scroll {
    @apply px-5 sm:px-0;
  }
  .n-tabs-tab {
    @apply text-base px-4 py-3 md:py-5;
  }
}
</style>
